import { IPOConfigFromBackend } from '@app/@types/po/poConfig'

const checkIfControlledInputs = (items: Array<IPOConfigFromBackend>): boolean => items.some((el) => el.type !== 'text')

export default checkIfControlledInputs
